import { createMuiTheme } from '@material-ui/core';
import { GLOBAL_FONT_THEME } from '../../../theme/CommonTheme';

export const theme = createMuiTheme({
    typography: GLOBAL_FONT_THEME,
    overrides: {
        MuiSnackbarContent: {
            root: {
                background: '#5E9331 !important'
            }
        }
    }
});
export const SNACK_BAR_SUCCESS_THEME = createMuiTheme({
    overrides: {
        MuiSnackbarContent: {
            root: {
                background: '#5E9331 !important'
            }
        }
    },
    typography: GLOBAL_FONT_THEME
});

export const SNACK_BAR_FAILURE_THEME = createMuiTheme({
    overrides: {
        MuiSnackbarContent: {
            root: {
                background: theme.palette.error.dark
            }
        }
    },
    typography: GLOBAL_FONT_THEME
});

export const SNACK_BAR_DANGER_THEME = createMuiTheme({
    overrides: {
        MuiSnackbarContent: {
            root: {
                background: '#A51D25 !important'
            }
        }
    },
    typography: GLOBAL_FONT_THEME
});
